import type { SubscribedOnDataDto } from '@api'

export const getSubcriptionState = (data?: SubscribedOnDataDto) => {
  if (!data) {
    return { isExpired: false, isSubscribed: false }
  }
  const { subscribeAt, expiredAt } = data
  const isSubscribed =
    !!subscribeAt && !!expiredAt && new Date(expiredAt).getTime() > Date.now()
  const isExpired = !!expiredAt && new Date(expiredAt).getTime() <= Date.now()

  return { isExpired, isSubscribed }
}
